import type { ReactNode } from "react";

export interface DetailRowProps {
  readonly label: string;
  readonly value: ReactNode;
}

/** Label/value pair for sidebar summary `<dl>` grids (Billing, Integrations, etc.). */
export function DetailRow({ label, value }: DetailRowProps) {
  return (
    <div className="min-w-0 flex flex-col gap-0.5">
      <dt className="text-xs font-medium uppercase tracking-wide text-text-tertiary">
        {label}
      </dt>
      <dd className="min-w-0 break-words text-sm text-gray-900">{value}</dd>
    </div>
  );
}

/** Em dash placeholder for missing sidebar summary values. */
export function EmptyValue() {
  return <span className="text-text-tertiary">—</span>;
}
